import { render, staticRenderFns } from "./Func138.vue?vue&type=template&id=06165146"
import script from "./Func138.vue?vue&type=script&lang=js"
export * from "./Func138.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports